module.exports = __webpack_public_path__ + "static/img/15-box.70eac26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15-box.png
// module id = e/TU
// module chunks = 0